(function(){
  var el=document.getElementById('mes-config');
  if(!el)return;
  var cfg=JSON.parse(el.textContent);
  var TN=cfg.TN,CDN='https://'+TN+'.myshopishop.com';
  var CURRENCY=cfg.CURRENCY||'AUD';
  var P=cfg.P;
  var RRP_PER=cfg.RRP||[140,120,120,130,130];
  var SIZES=['XXS','XS','S','M','L','XL','XXL','XXXL'];

  // Desktop scroll arrows for carousels (desktop only)
  function addScrollArrows(track){
    if(!window.matchMedia('(min-width:768px)').matches||!track)return;
    var wrap=track.parentElement;
    if(!wrap)return;
    if(getComputedStyle(wrap).position==='static')wrap.style.position='relative';
    if(wrap.querySelector('.mes-scroll-arrow'))return;
    var btnCss='position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;background:rgba(0,0,0,0.6);color:#fff;border:none;font-size:18px;cursor:pointer;z-index:5;display:none;align-items:center;justify-content:center;';
    var left=document.createElement('button');left.type='button';left.className='mes-scroll-arrow';
    left.style.cssText=btnCss+'left:6px;';left.innerHTML='\u2039';
    var right=document.createElement('button');right.type='button';right.className='mes-scroll-arrow';
    right.style.cssText=btnCss+'right:6px;';right.innerHTML='\u203A';
    wrap.appendChild(left);wrap.appendChild(right);
    function update(){
      var sl=track.scrollLeft,max=track.scrollWidth-track.clientWidth;
      left.style.display=sl>10?'flex':'none';
      right.style.display=max-sl>10?'flex':'none';
    }
    left.addEventListener('click',function(e){e.stopPropagation();track.scrollBy({left:-track.clientWidth*0.8,behavior:'smooth'});});
    right.addEventListener('click',function(e){e.stopPropagation();track.scrollBy({left:track.clientWidth*0.8,behavior:'smooth'});});
    track.addEventListener('scroll',update);
    // Check repeatedly until layout is ready
    var checks=0;
    var iv=setInterval(function(){
      update();
      checks++;
      if(checks>20)clearInterval(iv);
    },200);
  }
  var TRIS=[{v:'t1',l:'1st'},{v:'t2',l:'2nd'},{v:'t3',l:'3rd'}];

  // Kit item quantities: P[0]=mat leggings, P[1]=crop, P[2]=mat shorts, P[3]=rec leggings, P[4]=rec shorts
  var KIT_QTY={
    single:     [1,0,0,0,0],
    essentials: [1,1,1,1,1],
    prepared:   [1,2,2,1,1],
    ultimate:   [1,2,2,2,2],
  };
  var KIT_ITEMS={single:1,essentials:5,prepared:7,ultimate:9};
  var KIT_CTA_LABELS={
    single:'Add Leggings',
    essentials:'Add Essentials Set',
    prepared:'Add Complete Set',
    ultimate:'Add Best Value Set'
  };

  // Pricing: loaded from the same cart-bundle-config.json the discount function uses
  var S='$',tierPrice=35; // defaults until config loads
  var KITS={
    single:     {price:35,  label:'Just the Maternity Leggings', qty:KIT_QTY.single, totalItems:1},
    essentials: {price:175, label:'Maternity Essentials',        qty:KIT_QTY.essentials, totalItems:5},
    prepared:   {price:245, label:'Complete Maternity Set',   qty:KIT_QTY.prepared, totalItems:7},
    ultimate:   {price:315, label:'Hospital Bag + Beyond Set', qty:KIT_QTY.ultimate, totalItems:9},
  };

  function fmtMoney(amount){ return S+Math.round(amount); }
  function updateKitPickerCopy(){
    var essentialsSaved=(RRP_PER[0]+RRP_PER[1]+RRP_PER[2]+RRP_PER[3]+RRP_PER[4])-KITS.essentials.price;
    var preparedSaved=(RRP_PER[0]+(2*RRP_PER[1])+(2*RRP_PER[2])+RRP_PER[3]+RRP_PER[4])-KITS.prepared.price;
    var ultimateSaved=(RRP_PER[0]+(2*RRP_PER[1])+(2*RRP_PER[2])+(2*RRP_PER[3])+(2*RRP_PER[4]))-KITS.ultimate.price;
    var diff7=KITS.prepared.price-KITS.essentials.price;
    var copyEss=document.getElementById('kit-copy-essentials');
    var proofEss=document.getElementById('kit-proof-essentials');
    var copyPrep=document.getElementById('kit-copy-prepared');
    var proofPrep=document.getElementById('kit-proof-prepared');
    var copyUlt=document.getElementById('kit-copy-ultimate');
    var proofUlt=document.getElementById('kit-proof-ultimate');
    if(copyEss)copyEss.textContent='Most mums start here';
    if(proofEss)proofEss.textContent='Save '+fmtMoney(essentialsSaved)+' vs buying separately';
    if(copyPrep)copyPrep.textContent='Free shipping included';
    if(proofPrep)proofPrep.textContent='Only '+fmtMoney(diff7)+' more than the essentials';
    if(copyUlt)copyUlt.textContent='Best price per item';
    if(proofUlt)proofUlt.textContent='Save '+fmtMoney(ultimateSaved)+' vs buying separately';
  }

  // Fetch real pricing from bundle config
  if(cfg.BUNDLE_CONFIG_URL){
    fetch(cfg.BUNDLE_CONFIG_URL).then(function(r){return r.json();}).then(function(allCfg){
      var cc=allCfg[CURRENCY]||allCfg.AUD||{};
      var tiers=(cc.tiers||[]).sort(function(a,b){return a.min_qty-b.min_qty;});
      // Currency symbol
      if(CURRENCY==='GBP')S='\u00A3';else if(CURRENCY==='EUR')S='\u20AC';else if(CURRENCY==='SGD')S='S$';else S='$';

      function priceForQty(qty){
        var p=tiers[0]?tiers[0].price:35;
        for(var i=0;i<tiers.length;i++){if(qty>=tiers[i].min_qty)p=tiers[i].price;}
        return p;
      }

      // Compute kit prices from tiers
      for(var k in KIT_ITEMS){
        var q=KIT_ITEMS[k];
        var pp=priceForQty(q);
        KITS[k].price=Math.round(pp*q);
      }

      // Update variant selector prices
      for(var kn in KITS){
        var priceEl=document.getElementById('price-'+kn);
        if(priceEl&&kn!=='single')priceEl.textContent=S+KITS[kn].price;
        else if(priceEl&&kn==='single')priceEl.textContent=S+KITS[kn].price;
      }
      updateKitPickerCopy();

      // Expose for custom item pricing
      window._mesPriceForQty=priceForQty;

      // Refresh current state
      updSavings();updAtc();
    }).catch(function(){});
  }

  // ── Custom items (non-set products added by user) ──
  var customItems=[]; // [{handle,name,variantId,qty,rrp}]
  var productCache={}; // handle -> {title,variants:[{id,title,available,price}]}

  function fetchProduct(handle){
    if(productCache[handle])return Promise.resolve(productCache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(d){
      var prod={title:d.title,image:d.featured_image,variants:d.variants.map(function(v){return{id:v.id,title:v.title,available:v.available,price:v.price};})};
      productCache[handle]=prod;
      return prod;
    }).catch(function(){return null;});
  }

  function getCustomTotalQty(){
    var q=0;customItems.forEach(function(ci){q+=ci.qty;});return q;
  }

  function getTotalItemCount(){
    return KIT_ITEMS[kit]+getCustomTotalQty();
  }

  function getCustomItemPrice(){
    if(!window._mesPriceForQty)return 35;
    return window._mesPriceForQty(getTotalItemCount());
  }

  function addCustomItem(handle,name,rrp){
    // Check if already added
    for(var i=0;i<customItems.length;i++){if(customItems[i].handle===handle)return;}
    var userSz=(sz||'M').toUpperCase();
    fetchProduct(handle).then(function(prod){
      if(!prod)return;
      // Find variant matching user's size
      var variant=null;
      for(var i=0;i<prod.variants.length;i++){
        if(prod.variants[i].title.toUpperCase()===userSz&&prod.variants[i].available){variant=prod.variants[i];break;}
      }
      if(!variant){
        // Fallback: first available
        for(var i=0;i<prod.variants.length;i++){if(prod.variants[i].available){variant=prod.variants[i];break;}}
      }
      if(!variant)return;
      customItems.push({handle:handle,name:name||prod.title,variantId:variant.id,qty:1,rrp:Math.round(variant.price/100)});
      renderCustomItems();
      updSavings();updAtc();
    });
  }

  function renderCustomItems(){
    var container=document.getElementById('mes-custom-items');
    if(!container){
      // Create the section if it doesn't exist
      var grid=document.getElementById('mes-product-grid');
      if(!grid){
        var included=document.getElementById('savings-box');
        if(!included)return;
        var section=document.createElement('div');
        section.id='mes-custom-items';
        section.style.cssText='margin:12px 0 0 0;';
        included.parentElement.insertBefore(section,included);
        container=section;
      }
    }
    if(!container)return;
    if(!customItems.length){container.style.display='none';return;}
    container.style.display='block';
    var h='<div style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:0.04em;color:#3D9A8B;margin:0 0 8px 0;">Added to your set</div>';
    h+='<div style="display:flex;flex-direction:column;border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;">';
    customItems.forEach(function(ci,idx){
      var border=idx>0?'border-top:1px solid #f3f4f6;':'';
      h+='<div style="display:flex;align-items:center;gap:10px;padding:10px 12px;'+border+'">';
      h+='<div style="flex:1;min-width:0;"><div style="font-size:14px;font-weight:600;">'+ci.name+' <span style="font-size:11px;color:#E8846C;font-weight:700;">x'+ci.qty+'</span></div>';
      h+='<div style="font-size:11px;color:#6b7280;">'+S+getCustomItemPrice()+' each</div></div>';
      // Qty controls
      h+='<div style="display:flex;align-items:center;gap:4px;">';
      h+='<button data-ci-minus="'+idx+'" type="button" style="width:26px;height:26px;border:1px solid #e5e7eb;border-radius:4px;background:#fff;font-size:13px;cursor:pointer;">\u2212</button>';
      h+='<span style="min-width:18px;text-align:center;font-size:13px;font-weight:600;">'+ci.qty+'</span>';
      h+='<button data-ci-plus="'+idx+'" type="button" style="width:26px;height:26px;border:1px solid #e5e7eb;border-radius:4px;background:#fff;font-size:13px;cursor:pointer;">+</button>';
      h+='</div>';
      h+='<span style="font-size:13px;color:#9ca3af;text-decoration:line-through;flex-shrink:0;">'+S+ci.rrp+'</span>';
      h+='</div>';
    });
    h+='</div>';
    container.innerHTML=h;
    // Wire qty buttons
    container.querySelectorAll('[data-ci-minus]').forEach(function(b){
      b.addEventListener('click',function(){
        var i=parseInt(b.getAttribute('data-ci-minus'));
        if(customItems[i].qty>0)customItems[i].qty--;
        if(customItems[i].qty===0)customItems.splice(i,1);
        renderCustomItems();updSavings();updAtc();
      });
    });
    container.querySelectorAll('[data-ci-plus]').forEach(function(b){
      b.addEventListener('click',function(){
        var i=parseInt(b.getAttribute('data-ci-plus'));
        if(customItems[i].qty<5)customItems[i].qty++;
        renderCustomItems();updSavings();updAtc();
      });
    });
  }

  // Only the 5 exact set products
  var PRODUCT_NAME_MAP={
    '7-8-mat-pocket-leggings-black':'7/8 Maternity Leggings + Pockets',
    'emama-longline-crop':'Nursing Crop',
    'shorts-mat-pocket-black':'Maternity Shorts + Pockets',
    'pregnancy-recovery-emama-7-8-leggings-pockets':'7/8 Recovery Leggings + Pockets',
    'pregnancy-recovery-emama-shorts-pockets':'Recovery Shorts + Pockets',
  };
  var STAGE_LABELS={t1:'in her 1st trimester',t2:'in her 2nd trimester',t3:'in her 3rd trimester',p:'post partum',k:'living her mum life'};
  var P=cfg.P;
  var kit='essentials',sz=null,tri=null,allUgc=[];
  var soundOn=false;
  function ru(u){if(!u)return'';return u.startsWith('http')?u:CDN+(u.startsWith('/')?'':'/')+u;}

  // ── Video visibility ──
  // Mobile: play one at a time. Desktop: play all visible.
  var _isDsk=window.matchMedia('(min-width:768px)').matches;
  var activeVideo=null;
  function setupVideoVisibility(){
    if(!('IntersectionObserver' in window))return;
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var vid=entry.target;
        if(entry.isIntersecting){
          if(!_isDsk){
            // Mobile: one at a time
            if(activeVideo&&activeVideo!==vid){try{activeVideo.pause();}catch(e){}}
            activeVideo=vid;
          }
          try{vid.play();}catch(e){}
        }else{
          try{vid.pause();}catch(e){}
          if(activeVideo===vid)activeVideo=null;
        }
      });
    },{threshold:0.5});
    document.querySelectorAll('video').forEach(function(v){
      if(!v.closest('#ugc-wall-grid'))obs.observe(v);
    });
    window._mesVideoObs=obs;
  }
  function observeNewVideos(container){
    if(!window._mesVideoObs)return;
    container.querySelectorAll('video').forEach(function(v){
      if(!v.closest('#ugc-wall-grid'))window._mesVideoObs.observe(v);
    });
    container.querySelectorAll('video').forEach(function(v){
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  // Sound toggle — tap unmutes that video, mutes all others
  function addSoundBtn(container){
    var videos=container.querySelectorAll('video');
    videos.forEach(function(vid){
      if(vid.parentElement.querySelector('.mes-sound-btn'))return;
      vid.muted=true;
      var btn=document.createElement('button');
      btn.className='mes-sound-btn';
      btn.type='button';
      btn.style.cssText='position:absolute;bottom:12px;right:12px;width:36px;height:36px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;';
      btn.innerHTML='\uD83D\uDD07';
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var wasMuted=vid.muted;
        // Mute all videos and reset all buttons
        document.querySelectorAll('video').forEach(function(v){v.muted=true;});
        document.querySelectorAll('.mes-sound-btn').forEach(function(b){b.innerHTML='\uD83D\uDD07';});
        // Toggle this one
        if(wasMuted){
          vid.muted=false;
          btn.innerHTML='\uD83D\uDD0A';
          soundOn=true;
        } else {
          soundOn=false;
        }
      });
      var wrapper=vid.parentElement;
      if(wrapper.style.position!=='relative'&&wrapper.style.position!=='absolute')wrapper.style.position='relative';
      wrapper.appendChild(btn);
    });
  }

  // ── Size/tri buttons ──
  function mkRow(id,opts,cur,cb){
    var el=document.getElementById(id);el.innerHTML='';
    opts.forEach(function(o){
      var v=typeof o==='string'?o:o.v,l=typeof o==='string'?o:o.l,a=cur===v;
      var b=document.createElement('button');b.type='button';b.textContent=l;
      b.style.cssText='padding:8px 14px;border:1.5px solid '+(a?'#E8846C':'#e5e7eb')+';border-radius:6px;background:'+(a?'#FFF8F6':'#fff')+';font-size:14px;font-weight:600;cursor:pointer;min-width:44px;color:'+(a?'#E8846C':'#1f2937')+';';
      b.addEventListener('click',function(){cb(v);});el.appendChild(b);
    });
  }
  function pickSz(v){sz=(sz===v?null:v);mkRow('sz-row',SIZES,sz,pickSz);updAtc();loadCarousels();}
  function pickTri(v){tri=(tri===v?null:v);mkRow('tri-row',TRIS,tri,pickTri);loadCarousels();}
  mkRow('sz-row',SIZES,sz,pickSz);mkRow('tri-row',TRIS,tri,pickTri);

  // ── Kit selector ──
  function pickKit(k){
    kit=k;
    var btns=document.querySelectorAll('#variant-selector button[data-kit]');
    btns.forEach(function(b){
      var isActive=b.getAttribute('data-kit')===k;
      b.style.borderColor=isActive?'#E8846C':'#e5e7eb';
      b.style.background=isActive?'#FFF8F6':'#fff';
    });
    updQtyBadges();
    updSavings();
    updAtc();
  }
  document.querySelectorAll('#variant-selector button[data-kit]').forEach(function(b){
    b.addEventListener('click',function(){pickKit(b.getAttribute('data-kit'));});
  });

  function updQtyBadges(){
    var k=KITS[kit];
    var ids=['p1','p3','p2','p4','p5']; // match product index order: 0=p1,1=crop(p2),2=shorts(p3),3=rec-leg(p4),4=rec-shorts(p5)
    // Map: p1=idx0, p2=idx1(crop), p3=idx2(shorts), p4=idx3, p5=idx4
    var qtyMap={p1:k.qty[0],p2:k.qty[1],p3:k.qty[2],p4:k.qty[3],p5:k.qty[4]};
    for(var id in qtyMap){
      var el=document.getElementById('qty-'+id);
      if(el)el.textContent=qtyMap[id]>1?'x'+qtyMap[id]:(qtyMap[id]===0?'':'');
      var row=document.getElementById('row-'+id);
      if(row)row.style.opacity=qtyMap[id]===0?'0.4':'1';
    }
  }

  function updSavings(){
    var k=KITS[kit];
    var customQty=getCustomTotalQty();
    var customPrice=customQty*getCustomItemPrice();
    var customRrp=0;
    customItems.forEach(function(ci){customRrp+=ci.rrp*ci.qty;});

    var kitRrp=0;
    k.qty.forEach(function(q,i){kitRrp+=q*RRP_PER[i];});
    var totalRrp=kitRrp+customRrp;
    var totalPrice=k.price+customPrice;
    var saved=totalRrp-totalPrice;
    var pct=totalRrp>0?Math.round(saved/totalRrp*100):0;

    var box=document.getElementById('savings-box');
    if(!box)return;
    if(kit==='single'&&!customQty){
      box.innerHTML='';box.style.display='none';return;
    }
    box.style.display='block';
    box.innerHTML='<div style="display:flex;justify-content:space-between;font-size:13px;color:#9ca3af;"><span>Total value</span><span style="text-decoration:line-through;">'+S+totalRrp+'</span></div>'+
      '<div style="display:flex;justify-content:space-between;font-size:16px;font-weight:800;color:#1f2937;margin-top:4px;"><span>Your price</span><span>'+S+totalPrice+'</span></div>'+
      '<div style="display:flex;justify-content:space-between;font-size:13px;font-weight:600;color:#3D9A8B;margin-top:2px;"><span>You save</span><span>'+S+saved+' ('+pct+'%)</span></div>';

    // Update selected kit price display to include custom items
    var priceEl=document.getElementById('price-'+kit);
    if(priceEl)priceEl.textContent=S+totalPrice;

    // Show custom item count under selected kit
    var customNote=document.getElementById('kit-custom-note');
    if(!customNote){
      var activeBtn=document.querySelector('#variant-selector button[data-kit="'+kit+'"]');
      if(activeBtn){
        customNote=document.createElement('div');
        customNote.id='kit-custom-note';
        customNote.style.cssText='font-size:11px;color:#3D9A8B;margin-top:3px;';
        var inner=activeBtn.querySelector('div > div');
        if(inner)inner.appendChild(customNote);
      }
    }
    if(customNote){
      if(customQty>0){
        var names=[];customItems.forEach(function(ci){names.push('x'+ci.qty+' '+ci.name);});
        customNote.textContent='+ '+names.join(', ');
      }else{
        customNote.textContent='';
      }
    }
  }

  // ── ATC ──
  var _kitSocialNums={single:'524',essentials:'8,354',prepared:'3,927',ultimate:'1,744'};
  function updAtc(){
    var k=KITS[kit];
    var customQty=getCustomTotalQty();
    var totalItems=k.totalItems+customQty;
    var customPrice=customQty*getCustomItemPrice();
    var totalPrice=k.price+customPrice;
    var ctaLabel=KIT_CTA_LABELS[kit]||'Add to Cart';
    var label='Select a size';
    if(sz){
      if(kit==='single'&&customQty===0){
        label=ctaLabel+' \u2014 '+fmtMoney(totalPrice);
      }else if(kit==='single'&&customQty>0){
        label='Add My Set \u2014 '+fmtMoney(totalPrice)+' ('+totalItems+' items)';
      }else{
        label=ctaLabel+' \u2014 '+fmtMoney(totalPrice)+' ('+totalItems+' items)';
      }
    }
    ['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.textContent=label;b.disabled=false;b.style.opacity='1';}});
    var sub=document.getElementById('atc-subtext');
    if(sub)sub.textContent='Bought by '+(_kitSocialNums[kit]||'8,354')+' mums this month \u00B7 Easy returns';
  }

  // Size picker modal (shown when ATC tapped without a size)
  function openSizeModal(){
    var modal=document.createElement('div');
    modal.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.5);display:flex;align-items:flex-end;justify-content:center;font-family:system-ui,-apple-system,sans-serif;';
    var inner='<div style="background:#fff;border-radius:16px 16px 0 0;padding:24px 20px 32px;max-width:480px;width:100%;">';
    inner+='<div style="display:flex;justify-content:space-between;align-items:center;margin:0 0 16px 0;"><div style="font-size:17px;font-weight:700;">Your normal leggings size</div><button id="sz-modal-close" style="background:none;border:none;font-size:20px;cursor:pointer;">\u2715</button></div>';
    inner+='<div id="sz-modal-row" style="display:flex;flex-wrap:wrap;gap:8px;"></div>';
    inner+='</div>';
    modal.innerHTML=inner;
    document.body.appendChild(modal);

    var row=modal.querySelector('#sz-modal-row');
    SIZES.forEach(function(s){
      var b=document.createElement('button');b.type='button';b.textContent=s;
      b.style.cssText='padding:12px 18px;border:1.5px solid #e5e7eb;border-radius:8px;background:#fff;font-size:15px;font-weight:600;cursor:pointer;min-width:52px;color:#1f2937;';
      b.addEventListener('click',function(){
        pickSz(s);
        modal.remove();
      });
      row.appendChild(b);
    });

    modal.querySelector('#sz-modal-close').addEventListener('click',function(){modal.remove();});
    modal.addEventListener('click',function(e){if(e.target===modal)modal.remove();});
  }

  function onAtcClick(){
    if(!sz){openSizeModal();return;}
    doAtc();
  }

  function doAtc(){
    if(!sz)return;
    var k=KITS[kit];
    var items=[];
    k.qty.forEach(function(q,i){
      if(q>0){var vid=P[i].v[sz];if(vid)items.push({id:vid,quantity:q});}
    });
    customItems.forEach(function(ci){
      if(ci.qty>0&&ci.variantId)items.push({id:ci.variantId,quantity:ci.qty});
    });
    if(!items.length)return;
    ['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=true;b.textContent='Adding...';}});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json();})
    .then(function(){if(kit==='single'){document.getElementById('upsell').style.display='flex';updAtc();}else{window.location.href='/cart';}})
    .catch(function(){['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=false;b.textContent='Something went wrong';}});});
  }
  document.getElementById('atc').addEventListener('click',onAtcClick);
  var _atc2=document.getElementById('atc2');if(_atc2)_atc2.addEventListener('click',onAtcClick);
  document.getElementById('atc-sticky').addEventListener('click',onAtcClick);
  document.getElementById('up-no').addEventListener('click',function(){document.getElementById('upsell').style.display='none';window.location.href='/cart';});
  document.getElementById('up-yes').addEventListener('click',function(){document.getElementById('upsell').style.display='none';pickKit('essentials');fetch('/cart/clear.js',{method:'POST'}).then(function(){var k=KITS.essentials;var items=[];k.qty.forEach(function(q,i){if(q>0){var vid=P[i].v[sz];if(vid)items.push({id:vid,quantity:q});}});return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});}).then(function(){window.location.href='/cart';});});

  // ── Sticky ATC: show when stage section is in view ──
  if('IntersectionObserver' in window){
    var stickyEl=document.getElementById('sticky-atc');
    var mainAtc=document.getElementById('atc');
    new IntersectionObserver(function(entries){
      stickyEl.style.display=entries[0].isIntersecting?'none':'block';
    },{threshold:0}).observe(mainAtc);
  }

  // ── Wearing info (under tile, not overlay) ──
  function stageText(item){
    if(item.trimester&&STAGE_LABELS[item.trimester])return STAGE_LABELS[item.trimester];
    if(item.stage==='m')return'in her pregnancy';
    if(item.stage==='p')return STAGE_LABELS.p;
    if(item.stage==='k')return STAGE_LABELS.k;
    return'';
  }

  function productLines(item){
    if(!item.products||!item.products.length)return[];
    var userSz=(sz||'XS').toUpperCase();
    var lines=[],seen={};
    item.products.forEach(function(prod){
      var name=PRODUCT_NAME_MAP[prod.handle];
      var isSet=!!name;
      if(!name)name=prod.title||prod.handle;
      if(seen[name])return;
      seen[name]=true;
      // Check if already added as custom
      var alreadyCustom=false;
      for(var ci=0;ci<customItems.length;ci++){if(customItems[ci].handle===prod.handle)alreadyCustom=true;}
      lines.push({name:name,size:userSz,inSet:isSet,handle:prod.handle,alreadyCustom:alreadyCustom});
    });
    return lines;
  }

  function buildInfoHtml(item){
    var h='<div style="padding:10px 12px;background:#111;font-size:12px;color:rgba(255,255,255,0.8);line-height:1.5;">';
    h+='<div>this is <strong>@'+(item.handle||'unknown')+'</strong> '+stageText(item)+'</div>';
    var prods=productLines(item);
    if(prods.length){
      h+='<div style="margin-top:4px;">she\u2019s wearing:</div>';
      prods.forEach(function(p,i){
        var prefix=i>0?'& ':'';
        if(p.inSet){
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#3D9A8B;color:#fff;padding:1px 4px;margin-left:4px;">in your set</span></div>';
        } else if(p.alreadyCustom){
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#3D9A8B;color:#fff;padding:1px 4px;margin-left:4px;">added</span></div>';
        } else {
          var addPrice=getCustomItemPrice();
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span class="mes-add-item" data-handle="'+p.handle+'" data-name="'+p.name.replace(/"/g,'&quot;')+'" style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#E8846C;color:#fff;padding:2px 6px;margin-left:4px;cursor:pointer;">add to your set '+S+addPrice+'</span></div>';
        }
      });
    }
    h+='</div>';
    return h;
  }

  // ── Build a card (media + info underneath) ──
  function buildCard(item,width){
    var card=document.createElement('div');
    card.style.cssText='flex:0 0 '+width+';max-width:'+width+';scroll-snap-align:start;overflow:hidden;background:#000;cursor:pointer;';
    var isV=item.type==='reel'||item.type==='video';
    var media;
    if(isV)media='<video src="'+ru(item.url)+'" poster="'+ru(item.posterUrl||'')+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
    else media='<img src="'+ru(item.url)+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
    card.innerHTML='<div style="position:relative;">'+media+'</div>'+buildInfoHtml(item);
    addSoundBtn(card);
    // Wire "add to your set" badges
    card.querySelectorAll('.mes-add-item').forEach(function(badge){
      badge.addEventListener('click',function(e){
        e.stopPropagation();
        addCustomItem(badge.getAttribute('data-handle'),badge.getAttribute('data-name'));
      });
    });
    card.addEventListener('click',function(e){
      if(e.target.closest('.mes-sound-btn')||e.target.closest('.mes-add-item'))return;
      var idx=0;
      for(var i=0;i<allUgc.length;i++){if(allUgc[i].id===item.id){idx=i;break;}}
      window.openUgcModal(allUgc,idx);
    });
    return card;
  }

  // ── Fetch stages ──
  var STAGES=[
    {tag:'m',tri:'t1',label:'1st Trimester'},
    {tag:'m',tri:'t2',label:'2nd Trimester'},
    {tag:'m',tri:'t3',label:'3rd Trimester'},
    {tag:'p',tri:null,label:'Postpartum'},
    {tag:'k',tri:null,label:'Mum Life'}
  ];

  // Fetch all maternity content once, then split by trimester client-side
  var fetchCache={};
  function fetchByTag(tag){
    if(fetchCache[tag])return Promise.resolve(fetchCache[tag]);
    var params='tenantId='+encodeURIComponent(TN)+'&pdp=true&limit=100&tags='+tag;
    if(sz) params+='&sizes='+encodeURIComponent(sz)+'&sizeField=bottoms';
    return fetch(CDN+'/api/ugc-gallery?'+params).then(function(r){return r.json();}).then(function(d){
      var items=d.ok&&d.items?d.items:[];
      fetchCache[tag]=items;
      return items;
    }).catch(function(){return[];});
  }
  function fetchStage(st){
    return fetchByTag(st.tag).then(function(items){
      if(!st.tri)return items; // p, k -- return all
      // For maternity, filter to matching trimester
      return items.filter(function(it){return it.trimester===st.tri;});
    });
  }

  function loadCarousels(){
    allUgc=[];fetchCache={};
    // Clear both mobile and desktop tracks
    for(var t=0;t<3;t++){
      var tr=document.getElementById('stage-track-'+t);if(tr)tr.innerHTML='';
      var dtr=document.getElementById('desk-stage-track-'+t);if(dtr)dtr.innerHTML='';
    }
    var _ss=document.getElementById('stage-section');if(_ss)_ss.style.display='none';
    var _dss=document.getElementById('desk-stage-section');if(_dss)_dss.style.display='none';
    var _smb=document.getElementById('see-more-btn');if(_smb)_smb.style.display='none';
    var _dsmb=document.getElementById('desk-see-more-btn');if(_dsmb)_dsmb.style.display='none';

    Promise.all(STAGES.map(fetchStage)).then(function(results){
      // Collect all items deduped
      var seen={},allItems=[];
      results.forEach(function(items){items.forEach(function(it){if(!seen[it.id]){seen[it.id]=true;allItems.push(it);}});});
      allUgc=allItems;

      // Build per-person stage map: { handle: { t1: item, t2: item, ... } }
      var personStages={};
      allItems.forEach(function(it){
        if(!it.handle)return;
        var sk=itemStageKey(it);
        if(!sk)return;
        if(!personStages[it.handle])personStages[it.handle]={};
        if(!personStages[it.handle][sk])personStages[it.handle][sk]=it;
      });

      // Rank people by how many stages they cover
      var people=Object.keys(personStages).sort(function(a,b){
        return Object.keys(personStages[b]).length-Object.keys(personStages[a]).length;
      }).slice(0,3);

      // Render: one person per row, strict stage order
      var globalUsed={};
      people.forEach(function(handle,rowIdx){
        var track=document.getElementById('stage-track-'+rowIdx);
        var dtrack=document.getElementById('desk-stage-track-'+rowIdx);
        var map=personStages[handle];
        STAGE_ORDER.forEach(function(sk){
          var it=map[sk];
          if(!it||globalUsed[it.id])return;
          globalUsed[it.id]=true;
          if(track)track.appendChild(buildCard(it,'80%'));
          if(dtrack)dtrack.appendChild(buildCard(it,'80%'));
        });
      });

      if(allItems.length){
        if(_ss){_ss.style.display='block';addSoundBtn(_ss);}
        if(_dss){_dss.style.display='block';addSoundBtn(_dss);}
        setupVideoVisibility();
        // Add desktop scroll arrows to all carousel tracks
        for(var ai=0;ai<3;ai++){
          addScrollArrows(document.getElementById('stage-track-'+ai));
          addScrollArrows(document.getElementById('desk-stage-track-'+ai));
        }
      }
      if(allItems.length>5){
        if(_smb)_smb.style.display='block';
        if(_dsmb)_dsmb.style.display='block';
      }
    });
  }
  loadCarousels();

  // See more buttons (mobile + desktop, both optional)
  var _seeMore=document.getElementById('see-more-btn');
  if(_seeMore){_seeMore.addEventListener('click',function(){
    if(allUgc.length)window.openUgcModal(allUgc,0);
  });}
  var _dSeeMore=document.getElementById('desk-see-more-btn');
  if(_dSeeMore){_dSeeMore.addEventListener('click',function(){
    if(allUgc.length)window.openUgcModal(allUgc,0);
  });}

  // ── UGC Modal (2 modes: journeys / by trimester) ──
  var STAGE_ORDER=['t1','t2','t3','p','k'];
  var STAGE_TAB_LABELS={t1:'1st Tri',t2:'2nd Tri',t3:'3rd Tri',p:'Postpartum',k:'Mum Life'};

  function stageSort(a,b){
    var aKey=a.trimester||(a.stage==='p'?'p':a.stage==='k'?'k':'z');
    var bKey=b.trimester||(b.stage==='p'?'p':b.stage==='k'?'k':'z');
    return STAGE_ORDER.indexOf(aKey)-STAGE_ORDER.indexOf(bKey);
  }

  function itemStageKey(it){return it.trimester||(it.stage==='p'?'p':it.stage==='k'?'k':null);}

  function buildCardHtml(it){
    var isV=it.type==='reel'||it.type==='video';
    var h='<div style="background:#000;overflow:hidden;position:relative;">';
    if(isV)h+='<video src="'+ru(it.url)+'" poster="'+ru(it.posterUrl||'')+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
    else h+='<img src="'+ru(it.url)+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
    h+='</div>';
    h+=buildInfoHtml(it);
    return h;
  }

  var _modalScrollY=0;
  function _lockBody(){_modalScrollY=window.scrollY;document.body.style.position='fixed';document.body.style.top='-'+_modalScrollY+'px';document.body.style.left='0';document.body.style.right='0';document.body.style.overflow='hidden';}
  function _unlockBody(){document.body.style.position='';document.body.style.top='';document.body.style.left='';document.body.style.right='';document.body.style.overflow='';window.scrollTo(0,_modalScrollY);}

  window.openUgcModal=function(items,si){
    _lockBody();
    var el=document.createElement('div');el.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.85);display:flex;justify-content:center;align-items:stretch;';
    var ci=si||0;
    var modalMode='journeys';
    var activeTab='all';
    var mySizesOnly=true;

    function getFiltered(){
      var pool=items;
      if(modalMode==='trimester'){
        if(activeTab!=='all')pool=pool.filter(function(it){return itemStageKey(it)===activeTab;});
        if(mySizesOnly&&sz){
          var uSz=sz.toUpperCase();
          pool=pool.filter(function(it){
            var vals=((it.bottoms||'')+(','+(it.tops||''))).split(',').map(function(s){return s.trim().toUpperCase();}).filter(Boolean);
            return !vals.length||vals.indexOf(uSz)>=0;
          });
        }
      }
      return pool;
    }

    // Inject scrollbar-hide style once
    if(!document.getElementById('ugc-modal-style')){
      var st=document.createElement('style');st.id='ugc-modal-style';
      st.textContent='#m-content div::-webkit-scrollbar{display:none;}';
      document.head.appendChild(st);
    }

    function render(){
      var h='<div style="width:100%;background:#000;display:flex;flex-direction:column;height:100%;overflow:hidden;">';
      // Sticky header
      h+='<div style="position:sticky;top:0;z-index:10;background:rgba(0,0,0,0.95);padding:10px 16px 0;">';
      // Top row: close + shop
      h+='<div style="display:flex;justify-content:space-between;align-items:center;margin:0 0 10px 0;"><button id="mx" style="color:white;background:none;border:none;font-size:20px;cursor:pointer;">\u2715</button><button id="mshop" style="color:#FFF8E7;background:#E8846C;border:none;padding:8px 16px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;">Shop set</button></div>';
      // Mode tabs
      h+='<div style="display:flex;gap:0;margin:0 0 8px 0;">';
      h+='<button id="mt-j" style="flex:1;padding:8px;font-size:12px;font-weight:700;border:none;cursor:pointer;'+(modalMode==='journeys'?'background:#E8846C;color:#FFF8E7;':'background:#222;color:#999;')+'">See their journeys</button>';
      h+='<button id="mt-t" style="flex:1;padding:8px;font-size:12px;font-weight:700;border:none;cursor:pointer;'+(modalMode==='trimester'?'background:#E8846C;color:#FFF8E7;':'background:#222;color:#999;')+'">By trimester</button>';
      h+='</div>';
      // Trimester sub-tabs (only in trimester mode)
      if(modalMode==='trimester'){
        h+='<div style="display:flex;gap:4px;overflow-x:auto;scrollbar-width:none;margin:0 0 6px 0;">';
        h+='<button data-tab="all" style="padding:5px 10px;font-size:11px;font-weight:600;border:none;cursor:pointer;white-space:nowrap;'+(activeTab==='all'?'background:white;color:black;':'background:#333;color:#aaa;')+'">All</button>';
        STAGE_ORDER.forEach(function(sk){
          h+='<button data-tab="'+sk+'" style="padding:5px 10px;font-size:11px;font-weight:600;border:none;cursor:pointer;white-space:nowrap;'+(activeTab===sk?'background:white;color:black;':'background:#333;color:#aaa;')+'">'+STAGE_TAB_LABELS[sk]+'</button>';
        });
        h+='</div>';
        h+='<div style="margin:0 0 8px 0;"><label style="display:flex;align-items:center;gap:6px;font-size:11px;color:#aaa;cursor:pointer;"><input type="checkbox" id="m-mysz" '+(mySizesOnly?'checked':'')+' style="accent-color:#E8846C;"> Showing my sizes only</label></div>';
      }
      h+='</div>';

      // Content area
      h+='<div id="m-content" style="flex:1;overflow-y:auto;"></div>';

      // Bottom ATC
      h+='<div style="padding:12px 16px;background:rgba(0,0,0,0.95);"><button id="m-atc" style="width:100%;padding:14px;background:#E8846C;color:#FFF8E7;font-size:16px;font-weight:700;border:none;border-radius:10px;cursor:pointer;">Add Full Set \u2014 '+S+KITS[kit].price+'</button></div>';
      h+='</div>'; // close inner wrapper

      el.innerHTML=h;

      // Render content (use el.querySelector since el isn't in DOM yet)
      var content=el.querySelector('#m-content');
      var filtered=getFiltered();

      if(modalMode==='journeys'){
        // One horizontal carousel per person, scroll down for more people
        var groups={},order=[];
        filtered.forEach(function(it){
          var key=it.handle||('_'+it.id);
          if(!groups[key]){groups[key]=[];order.push(key);}
          groups[key].push(it);
        });

        // Put the focused person first
        var focusedItem=items[ci];
        var focusedHandle=focusedItem?focusedItem.handle||('_'+focusedItem.id):null;
        if(focusedHandle&&order.indexOf(focusedHandle)>0){
          order.splice(order.indexOf(focusedHandle),1);
          order.unshift(focusedHandle);
        }

        order.forEach(function(handle){
          var personItems=groups[handle].sort(stageSort);
          var header=document.createElement('div');
          header.style.cssText='padding:12px 16px 6px;font-size:14px;font-weight:700;color:white;';
          header.textContent='@'+handle;
          content.appendChild(header);
          var track=document.createElement('div');
          track.style.cssText='display:flex;gap:2px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding:0 0 12px 0;';
          var scrollToCard=null;
          personItems.forEach(function(it){
            var card=document.createElement('div');
            var _dsk=window.matchMedia('(min-width:768px)').matches;
            card.style.cssText='flex:0 0 '+(_dsk?'390px':'85%')+';max-width:'+(_dsk?'390px':'85%')+';scroll-snap-align:start;overflow:hidden;background:#000;';
            card.innerHTML=buildCardHtml(it);
            if(focusedItem&&it.id===focusedItem.id) scrollToCard=card;
            track.appendChild(card);
          });
          var trackWrap=document.createElement('div');
          trackWrap.style.cssText='position:relative;';
          trackWrap.appendChild(track);
          content.appendChild(trackWrap);
          addScrollArrows(track);
          // Scroll to the focused card within this person's track
          if(scrollToCard){
            setTimeout(function(){scrollToCard.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});},50);
          }
        });
      } else {
        var sorted=filtered.slice().sort(stageSort);
        sorted.forEach(function(it){
          content.innerHTML+=buildCardHtml(it);
        });
      }

      // Add sound buttons and visibility observer to modal videos
      addSoundBtn(el);
      observeNewVideos(el);

      // Wire "add to your set" badges in modal
      el.querySelectorAll('.mes-add-item').forEach(function(badge){
        badge.addEventListener('click',function(e){
          e.stopPropagation();
          addCustomItem(badge.getAttribute('data-handle'),badge.getAttribute('data-name'));
          badge.textContent='added';badge.style.background='#3D9A8B';badge.style.cursor='default';
        });
      });

      // Wire events (use el.querySelector throughout)
      el.querySelector('#mx').addEventListener('click',function(){_unlockBody();el.remove();});
      el.querySelector('#mshop').addEventListener('click',function(){_unlockBody();el.remove();document.getElementById('atc').scrollIntoView({behavior:'smooth',block:'center'});});
      el.querySelector('#m-atc').addEventListener('click',function(){_unlockBody();el.remove();doAtc();});
      el.querySelector('#mt-j').addEventListener('click',function(){modalMode='journeys';activeTab='all';render();});
      el.querySelector('#mt-t').addEventListener('click',function(){modalMode='trimester';render();});
      el.querySelectorAll('[data-tab]').forEach(function(btn){
        btn.addEventListener('click',function(){activeTab=btn.getAttribute('data-tab');render();});
      });
      // My sizes toggle
      var myszCb=el.querySelector('#m-mysz');
      if(myszCb)myszCb.addEventListener('change',function(){mySizesOnly=myszCb.checked;render();});
    }
    document.body.appendChild(el);render();
  };

  pickKit('essentials');

})();
